/* eslint-disable jsx-a11y/img-redundant-alt */
import { BaSeHeading4, BaSeTheme } from '@base/react';
import React from 'react';
import { FormContext } from '../../hook/form-context';
import Select from '../select/select';
import { AlignCountry, ContentCountry } from './style';

function FormAddress() {
  const {
    handleSelectUf,
    listUfs,
    selectedUfOption,
    handleSelectCity,
    listCity,
    selectedCityOption,
  } = React.useContext(FormContext);

  return (
    <ContentCountry>
      <BaSeHeading4 color={BaSeTheme.colors.defaultColors.white}>
        Informe o Estado e Cidade do seu interesse
      </BaSeHeading4>
      <AlignCountry>
        <Select
          onChange={(event) => {
            handleSelectUf(event);
          }}
          label="Estado:"
          options={listUfs}
          value={selectedUfOption}
        />

        <Select
          onChange={(event) => {
            handleSelectCity(event);
          }}
          label="Cidade:"
          placeholder="Informe a cidade"
          options={listCity}
          value={selectedCityOption}
          isOptional={true}
        />
      </AlignCountry>
    </ContentCountry>
  );
}

export default FormAddress;
